import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  Checkbox,
  Collapse,
  IconButton,
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { SystemOneFeedRun } from "../SystemOneFeed";
import { ExcludedFeedPlate } from "./ExcludedPlate";

interface ExcludedFeedRunProps {
  run: SystemOneFeedRun;
  runIndex: number;
  plateWorklistInfo: any;
  updateExcludedRunSelection: (groupIndex: number) => void;
  updateExcludedPlateSelection: (
    groupIndex: number,
    plateIndex: number
  ) => void;
  updatePlateWorklistInfo: (
    key: string,
    value: string,
    runIndex: number,
    plateIndex: number
  ) => void;
}

export const ExcludedFeedRun = ({
  run,
  runIndex,
  plateWorklistInfo,
  updateExcludedRunSelection,
  updateExcludedPlateSelection,
  updatePlateWorklistInfo,
}: ExcludedFeedRunProps) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton
            style={{ outline: 0 }}
            aria-label="expand row"
            size="small"
            onClick={() => setCollapseOpen(!collapseOpen)}
          >
            {collapseOpen ? (
              <KeyboardArrowDownIcon />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
          <Checkbox
            checked={plateWorklistInfo.selected}
            onChange={() => updateExcludedRunSelection(runIndex)}
            disabled={run.reason === "Exists in Active Reservation"}
          />
        </TableCell>
        <TableCell style={{ width: "75px" }}>{run.runName}</TableCell>
        <TableCell
          style={{
            color: run.reason === "Removed from Included Group" ? "red" : "",
          }}
        >
          {run.method ?? run.reason}
        </TableCell>
        <TableCell>{run.reservationDate}</TableCell>
      </TableRow>
      {run.plates && collapseOpen ? (
        <div>
          <Collapse in={collapseOpen} unmountOnExit>
            <Table style={{ position: "relative", left: "75px" }}>
              <TableHead>
                <TableCell></TableCell>
                <TableCell>Plate Barcode</TableCell>
                <TableCell>Wells</TableCell>
              </TableHead>
              {run.plates.map((plate, plateIndex) => (
                <ExcludedFeedPlate
                  runIndex={runIndex}
                  plateIndex={plateIndex}
                  reason={run.reason}
                  plateWorklistInfo={plateWorklistInfo.plates[plateIndex]}
                  updateExcludedPlateSelection={updateExcludedPlateSelection}
                ></ExcludedFeedPlate>
              ))}
            </Table>
          </Collapse>
        </div>
      ) : null}
    </>
  );
};
